import { render, staticRenderFns } from "./AssignTerminalToCustomerAccountForm.vue?vue&type=template&id=074d4d22&scoped=true&"
import script from "./AssignTerminalToCustomerAccountForm.vue?vue&type=script&lang=js&"
export * from "./AssignTerminalToCustomerAccountForm.vue?vue&type=script&lang=js&"
import style0 from "./AssignTerminalToCustomerAccountForm.vue?vue&type=style&index=0&id=074d4d22&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074d4d22",
  null
  
)

export default component.exports